import React from "react"
import PropTypes from "prop-types"
import { useSubscription } from "react-apollo"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { MdArrowForward } from "react-icons/md"
import { VERCEL_ADDED_SUBSCRIPTION } from "../queries"
import { Button, StyledModalActions, Text } from "gatsby-interface"
import { vercelIntegrationConfig as text } from "@modules/locales/default.js"
import LoadingFromExternalWindow from "@modules/ui/components/LoadingFromExternalWindow"
import { commonMessageTags, FormattedMessage } from "@modules/locales"

const propTypes = {
  siteName: PropTypes.string.isRequired,
  siteId: PropTypes.string.isRequired,
  onConnect: PropTypes.func.isRequired,
}

const useOpenVercelWindow = siteId => {
  const [isWindowOpened, setIsWindowOpened] = React.useState(false)

  const openWindow = () => {
    setIsWindowOpened(true)

    window.open(
      `${process.env.GATSBY_DASHBOARD_AUTHENTICATION_URL}/oauth/now?siteId=${siteId}`,
      `_blank`,
      `height=600,width=700`
    )
  }

  return [isWindowOpened, openWindow]
}

const useVercelConnect = (siteId, onConnect, setError) => {
  const { error } = useSubscription(VERCEL_ADDED_SUBSCRIPTION, {
    variables: {
      siteId,
    },
    onSubscriptionData: data =>
      onConnect(data.subscriptionData.data.nowIntegrationAdded),
  })

  React.useEffect(() => {
    if (error) {
      setError(error)
    }
  }, [error])
}

export function ConnectVercel({ siteName, siteId, onConnect }) {
  const [setError, errorAlert] = useTriggerErrorAlert()
  const [isWindowOpened, openWindow] = useOpenVercelWindow(siteId)

  useVercelConnect(siteId, onConnect, setError)

  if (isWindowOpened) {
    return (
      <LoadingFromExternalWindow
        style={{ minHeight: `auto` }}
        message={text.messages.authorizingVercel}
        onClick={openWindow}
      />
    )
  }

  return (
    <React.Fragment>
      <Text>
        <FormattedMessage
          message={text.headers.connectToSite}
          values={{ siteName }}
          tags={commonMessageTags}
        />
      </Text>
      {errorAlert}
      <StyledModalActions>
        <div />
        <Button onClick={openWindow} rightIcon={<MdArrowForward />}>
          {text.actions.connect}
        </Button>
      </StyledModalActions>
    </React.Fragment>
  )
}

ConnectVercel.propTypes = propTypes
